module.exports = __webpack_public_path__ + "img/related-post-06.8d3f6349.jpg";